import { baseFetch } from "./base";

function isImageOnApiOrigin(imageUrl: string): boolean {
  const base = process.env.REACT_APP_BASE_URL;
  if (!base) return false;
  try {
    return new URL(imageUrl).origin === new URL(base).origin;
  } catch {
    return false;
  }
}

export const downloadImageProxy = async (
  imageUrl: string,
  filename?: string
): Promise<Blob> => {
  try {
    if (isImageOnApiOrigin(imageUrl)) {
      const response = await baseFetch.get(imageUrl, {
        responseType: "blob",
      });
      return response.data;
    }

    const response = await baseFetch.get("/download-image", {
      params: {
        url: imageUrl,
        filename: filename,
      },
      responseType: "blob",
    });

    return response.data;
  } catch (error: any) {
    console.error("Error downloading image via proxy:", error);
    throw error;
  }
};

export const downloadAllImagesAsZip = async (
  imageUrls: string[],
  baseFilename: string = "images"
): Promise<Blob> => {
  try {
    const response = await baseFetch.post(
      "/download-images-zip",
      {
        urls: imageUrls,
        base_filename: baseFilename,
      },
      {
        responseType: "blob",
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Error downloading images as ZIP via proxy:", error);
    throw error;
  }
};
